import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromMenuItem} from '@Hooks/poster-editor/useGetKeyFromMenuItem';

const ICON_SIZE_MIN_VALUE = 10;
const ICON_SIZE_MAX_VALUE = 100;

export function MenuIconSizeOption(): ReactElement {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const iconsSize = useGetKeyFromMenuItem('iconsSize');
  const scaleX = useGetKeyFromMenuItem('scaleX');

  if (!activeItem || (activeItem && !('iconsSize' in activeItem)) || iconsSize === undefined || scaleX === undefined) {
    throw new Error('Item does not have iconsSize property');
  }

  const updateIconSize = (iconsSize: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        iconsSize,
      },
      {
        undoable,
      }
    );
  };

  const onChangeHandler = (updatedValue: number): void => {
    updateIconSize(updatedValue / scaleX, false);
  };

  const onChangeEnded = (updatedValue: number): void => {
    updateIconSize(updatedValue / scaleX);
  };

  return (
    <ContextualMenuSliderOptions
      id="menu-icon-size-option"
      value={Math.round(iconsSize * scaleX)}
      label={window.i18next.t('pmwjs_size')}
      range={{
        min: ICON_SIZE_MIN_VALUE,
        max: ICON_SIZE_MAX_VALUE,
      }}
      transformDisplay={{
        min: ICON_SIZE_MIN_VALUE,
        max: ICON_SIZE_MAX_VALUE,
      }}
      onChange={onChangeHandler}
      onChangeEnded={onChangeEnded}
    />
  );
}
